import React from "react";
import { LayoutGrid } from "lucide-react";

export const logoSrc = (u) => (u ? `${process.env.REACT_APP_BACKEND_URL}${u}` : "");
const initials = (n) => String(n || "").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toLocaleUpperCase("tr-TR");

const FX3D = { filter: "drop-shadow(0 3px 4px rgba(0,0,0,.45)) drop-shadow(0 1px 0 rgba(255,255,255,.18))" };

export function BrandMark({ brand, size = 36, maxW }) {
  const box = { width: size, height: size };
  if (brand?.logo_url && (brand.logo_style || "WIDE") === "WIDE") {
    return <img data-testid="brand-logo" src={logoSrc(brand.logo_url)} alt={brand.name || "logo"} draggable={false} className="shrink-0 object-contain"
      style={{ height: size, width: "auto", maxWidth: maxW || size * 4.5, ...(brand.logo_fx === "3D" ? FX3D : {}) }} />;
  }
  if (brand?.logo_url) {
    return (
      <div data-testid="brand-logo" style={{ ...box, ...(brand.logo_fx === "3D" ? { boxShadow: "0 6px 14px rgba(0,0,0,.45), inset 0 1px 0 rgba(255,255,255,.6)" } : {}) }} className="flex shrink-0 items-center justify-center overflow-hidden rounded-xl bg-white p-[3px] ring-1 ring-black/10">
        <img src={logoSrc(brand.logo_url)} alt={brand.name || "logo"} className="h-full w-full object-contain" draggable={false} />
      </div>
    );
  }
  if (brand?.name) {
    return (
      <div data-testid="brand-initials" style={{ ...box, fontSize: size * 0.38 }} className="flex shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 font-head font-extrabold tracking-tight text-white shadow-lg">
        {initials(brand.name)}
      </div>
    );
  }
  return (
    <div style={box} className="flex shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg">
      <LayoutGrid className="h-1/2 w-1/2 text-white" />
    </div>
  );
}

export function BrandName({ brand, className = "" }) {
  if (brand?.name && brand.logo_url && brand.show_name === false) return brand.hide_mw ? null : <div className={`text-[10px] font-semibold tracking-wider text-slate-500 ${className}`}>MW<span className="text-blue-400/80">CRMPRO</span> İLE</div>;
  if (!brand?.name) return <div className={`font-head text-xl font-extrabold tracking-tight text-white ${className}`}>MW<span className="text-blue-400">CRMPRO</span></div>;
  return (
    <div className={`min-w-0 leading-tight ${className}`}>
      <div data-testid="brand-name" className="line-clamp-2 font-head text-[15px] font-extrabold tracking-tight text-white">{brand.name}</div>
      {!brand.hide_mw && <div className="text-[10px] font-semibold tracking-wider text-slate-500">MW<span className="text-blue-400/80">CRMPRO</span> İLE</div>}
    </div>
  );
}
